__turbopack_context__.v({
  "fieldset": "VotingQuestion-module__1jJh0q__fieldset",
});
